import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FeaturesComponent } from './features/features.component';
import { MasterComponent } from './components/master/master/master.component';

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'login' },
    { path: 'login', loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule) },
    {
        path: '',
        component: FeaturesComponent,
        children: [
            { path: 'dashboard', loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.DashboardModule)},
            { path: 'customer', loadChildren: () => import('./components/customer/customer.module').then(m => m.CustomerModule)},
            { path: 'aggregator', loadChildren: () => import('./components/aggregator/aggregator.module').then(m => m.AggregatorModule)},
            { path: 'auction', loadChildren: () => import('./components/auction/auction.module').then(m => m.AuctionModule)},
            { path: 'auctionlisting', loadChildren: () => import('./components/auctionListing/auctionlisting.module').then(m => m.AuctionlistingModule)},
            { path: 'biddata', loadChildren: () => import('./components/bid-data/bid-data.module').then(m => m.BidDataModule)},
            { path: 'report', loadChildren: () => import('./components/report/report.module').then(m => m.ReportModule) },
            { path: 'retial-pacs', loadChildren: () => import('./components/retail/retail.module').then(m => m.RetailModule) },
            { path: 'nccf', loadChildren: () => import('./components/nccf/nccf.module').then(m => m.NccfModule) },
            {
                path: 'master',
                component : MasterComponent,
                children :[
                    { path: '', loadChildren: () => import('./components/master/master.module').then(m => m.MasterModule) },
                ]
            }
        ]
    },
    { path: '**', redirectTo:'login'}
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {})
    ],
    exports: [RouterModule],
    providers: []
})
export class AppRoutingModule { }
